<template>
  <a-modal
    v-model="visible"
    centered
    :mask-closable="false"
    :width="480"
    :footer="null"
    @cancel="hideModal"
  >
    <div class="outer">
      <div v-if="uploadStep===1">
        <p class="uploadTitle">
          上传我的业绩目标
        </p>
        <p class="uploadT1">
          本地上传 Excel 文件
        </p>
        <p class="uploadT2">
          不符合格式的Excel会导致上传失败
        </p>
        <a-upload
          name="file"
          action="/api/okr/file/excel/check"
          :show-upload-list="false"
          @change="checkFile"
        >
          <a-button
            type="primary"
            class="submitBtn"
          >
            <a-icon type="upload" />上 传
          </a-button>
        </a-upload>
        <p class="uploadT3">
          <span>或</span>
        </p>
        <a-button
          type="link"
          icon="download"
          @click="downloadTemplae"
        >
          下载业绩目标模板
        </a-button>
      </div>
      <div v-if="uploadStep===2">
        <img
          class="uploadIco1"
          src="@assets/images/up-waiting.png"
        >
        <p class="uploadT4">
          请确认是否覆盖？
        </p>
        <p class="uploadT4_2">
          点击“确定”继续上传，点击“取消”中断上传
        </p>
        <div class="uploadBtns">
          <a-button @click="handleRestart">
            取消
          </a-button>
          <a-button
            type="primary"
            class="submitBtn"
            @click="handleCover"
          >
            确定
          </a-button>
        </div>
      </div>
      <div v-if="uploadStep===3">
        <a-icon
          type="loading"
          class="uploading"
        />
      </div>
      <div v-if="uploadStep===4">
        <img
          class="uploadIco1"
          src="@assets/images/up-success.png"
        >
        <div class="uploadT5">
          上传成功！<br>正在自动跳转至「编辑页面」
          <p class="uploadT2">
            Tips：在「编辑页面」确认上传内容点击 “提交”即可
          </p>
        </div>
        <div class="sucessTips">
          {{ CountDown }}秒
        </div>
        <!-- <a-button
          type="primary"
          class="submitBtn"
          @click="handleClickView"
        >
          查看详情
        </a-button> -->
      </div>
      <div v-if="uploadStep===5">
        <img
          class="uploadIco2"
          src="@assets/images/up-error.png"
        >
        <p class="uploadT6">
          {{ message }}
        </p>
        <a-upload
          name="file"
          action="/api/okr/file/excel/check"
          :show-upload-list="false"
          @change="checkFile"
        >
          <a-button type="primary">
            重新上传
          </a-button>
        </a-upload>
        <p class="uploadT3">
          <span>或</span>
        </p>
        <a-button
          type="link"
          icon="download"
          @click="downloadTemplae"
        >
          下载业绩目标模板
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import Vue from 'vue'
import { Modal, Button, Icon, Upload } from 'ant-design-vue'

Vue.use(Modal)
Vue.use(Button)
Vue.use(Icon)
Vue.use(Upload)

// 上传组件
export default {
  name: 'Upload',
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    step: {
      type: Number,
      default: null,
    },
    parame: {
      type: Object,
      default () {},
    },
  },
  data() {
    return {
      visible: false,
      uploadStep: null,
      message: '',
      temData: {},
      CountDown: '',
    }
  },
  file: undefined,
  watch: {
    show(val) {
      if (val) {
        this.uploadStep = this.step
      }
      this.visible = this.show
    },
  },
  methods: {
    hideModal() {
      this.$emit('close')
    },
    // 点击下载模板
    downloadTemplae() {
      const a = document.createElement('a')
      a.href = 'https://greedyint-dev.oss-cn-hangzhou.aliyuncs.com/XiaobaoOnline/psg/%E6%A0%A1%E5%AE%9D%E4%B8%AA%E4%BA%BA%E7%BB%A9%E6%95%88%E8%A1%A8%EF%BC%88%E6%A8%A1%E6%9D%BF%EF%BC%89.xlsx'
      a.target = '_blank'
      a.click()
    },
    // 校验excel
    async checkFile(info) {
      // 符合返回成功和解析的json数据（二次上传），不符合返回报错信息，重新上传
      if (info.file.status === 'done') {
        const result = info.file.response
        // eslint-disable-next-line
        console.log('parame', this.parame)
        if (!result.status) {
          this.message = result.message
          this.uploadStep = 5
        } else {
          if (!this.parame.id) {
            this.$set(this, 'temData', this.parame)
            this.temData.objectList = result.data.objectList
            // eslint-disable-next-line
            console.log('temData', this.temData)
            let timeout = null
            clearTimeout(timeout)
            this.uploadStep = 3
            timeout = setTimeout(() => {
              this.creatData()
            }, 1000)
          } else {
            this.uploadStep = 2
            this.$set(this, 'temData', this.parame)
            this.temData.objectList = result.data.objectList
          }
        }
      } else if (info.file.status === 'error') {
        // 网络异常报错
        this.message = '网络错误'
        this.uploadStep = 5
      }
    },
    // 校验通过，创建或覆盖原数据
    async creatData() {
      try {
        await this.$api.okr.preserve(this.temData)
        this.uploadStep = 4
        // 上传成功 3秒倒计时 跳转到编辑页
        const TIME_COUNT = 3
        this.CountDown = TIME_COUNT
        this.timer = setInterval(() => {
          if (this.CountDown > 1 && this.CountDown <= TIME_COUNT) {
            this.CountDown--
          } else {
            clearInterval(this.timer)
            this.timer = null
            // 跳转的页面写在此处
            if (this.parame.id) {
              this.$router.replace({
                name: 'EditOKR',
                params: {
                  okrId: this.parame.id,
                  year: this.parame.year,
                  quarter: this.parame.quarter,
                },
              })
            } else {
              this.$router.replace({
                name: 'NewOKR',
                params: { year: this.parame.year,
                  quarter: this.parame.quarter },
              })
            }
          }
        }, 1000)
      } catch (error) {
        // 网络异常报错
        const msg = error.errorMessage || error.message || '网络错误'
        this.message = msg
        this.uploadStep = 5
      }
    },
    handleCover() {
      let timeout = null
      clearTimeout(timeout)
      this.uploadStep = 3
      timeout = setTimeout(() => {
        this.creatData()
      }, 1000)
    },
    // 点击取消，返回伤处初始界面
    handleRestart() {
      this.uploadStep = 1
    },
    // 上传成功，点击进入OKR详情页
    handleClickView() {
      const { href } = this.$router.resolve({
        name: 'OKRDetail',
        params: { okrId: this.parame.id },
      })
      window.open(href, '_blank')
    },

  },
}
</script>

<style lang="less">
.outer{text-align: center; height: 272px;
.submitBtn { background-color: #005EFE;
&:hover {background-color: #0064fa;}
}
}
.uploadTitle{font-size:20px; margin-bottom: 24px; padding-top: 16px;}
.uploadT1{font-size:16px; margin-bottom: 8px;}
.uploadT2{font-size:14px; margin-bottom: 16px; color:#999;}
.uploadT3{position: relative; font-size:14px; margin-top: 15px; margin-bottom: 20px; color:#999; line-height: 32px; height: 32px;
span{position: relative; display:inline-block; padding: 0 16px; background-color: #fff; }
&::before{content: ""; position: absolute; top:16px; left:0; width: 100%; height: 1px; background-color: #999;}
}
.uploadIco1{width:66px; margin-top: 40px; margin-bottom: 30px;}
.uploadT4{font-size:14px; margin-bottom: 8px; color:#444;}
.uploadT4_2{font-size:12px; color:#bbb;}
.uploadT5{font-size:14px; margin-bottom: 36px;
.uploadT2{padding-top: 8px;}
}
.sucessTips{color:#999;}
.uploadBtns{font-size: 0;
button{ padding: 0 30px; }
button + button{margin-left: 40px;}
}
.uploading{position: absolute; top:50%; left:50%; margin:-26px 0 0 -26px; font-size:52px; color: #777;}
.uploadIco2{width:66px; margin-top: 15px; margin-bottom: 20px;}
.uploadT6{font-size:14px; margin-bottom: 20px;}
</style>
